import React, { useMemo } from 'react';
import { Header as Accordion, Trigger } from '@radix-ui/react-accordion';
import { Icon, IconsEnum } from 'components/Icons';

import { DynamicImage, enLoading } from 'components/Image';
import { ItemWithTranslation } from 'types/swagger';
import { isNotEmpty } from 'utility/functions';
import styles from './SportNavAccordionTrigger.module.scss';
import { useTranslation } from 'hooks/useLingUI';

export type SportNavAccordionTriggerProps = ItemWithTranslation<{ text: string }> & {
  iconSrc: string;
};

// eslint-disable-next-line react/display-name
export const SportNavAccordionTrigger = React.forwardRef<HTMLButtonElement, SportNavAccordionTriggerProps>(
  ({ text, textTrKey, iconSrc }, forwardedRef) => {
    const { t } = useTranslation();
    const txt = t(textTrKey, text);

    return (
      <Accordion>
        <Trigger className={styles.container} ref={forwardedRef} suppressHydrationWarning>
          <span className={styles.iconContainer}>
            {isNotEmpty(iconSrc) ? (
              <DynamicImage
                className={styles.iconCountry}
                src={iconSrc}
                alt={txt ?? ''}
                width={16}
                height={16}
                loading={enLoading.lazy}
                decoding="async"
              />
            ) : (
              <Icon iconId={IconsEnum.FULL_PIN} className={styles.iconCountry} color="var(--color-on-bg-primary)" />
            )}
          </span>
          <p className={styles.text}>{txt}</p>
          <Icon iconId={IconsEnum.CHEVRON_DOWN} className={styles.icon} color="var(--color-on-bg-secondary)" />
        </Trigger>
      </Accordion>
    );
  }
);